export default [
  "NOVELTY",
  "AUTO_STANDARD",
  "PICKUP",
  "UTILITARIO",
  "EQUIPO_PESADO",
  "MAQUINA_VIAL",
]